<template>
  <v-card v-if="success" class="pa-4" flat tile>
    <v-theme-provider>
      <div class="text-center">
        <v-avatar color="success" size="70">
          <v-icon large color="white">fas fa-check</v-icon>
        </v-avatar>
      </div>
    </v-theme-provider>

    <div class="d-flex justify-center body-heading-large text-center my-8">
      {{ successMsgTitle }}
    </div>
    <div class="d-flex justify-center body-text-small text-center my-8">
      {{ successMsgSubtitle }}
    </div>
    <v-card-text class="d-flex justify-center">
      <v-row v-if="successActions.length == 2">
        <v-col :key="successActions[0].name" cols="12" md="6" class="d-flex justify-center justify-md-end">
          <v-btn block outlined color="secondary" @click="successActions[0].event">{{ successActions[0].name }}</v-btn>
        </v-col>
        <v-col :key="successActions[1].name" cols="12" md="6" class="d-flex justify-center justify-md-start">
          <v-btn block color="secondary" @click="successActions[1].event">{{ successActions[1].name }}</v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col v-for="(action, index) in successActions" :key="action.name" cols="12" md="12" class="d-flex justify-center">
          <v-btn :outlined="index == 0" color="secondary" @click="action.event">{{ action.name }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-card v-else class="pa-4" flat>
    <v-theme-provider>
      <div class="text-center">
        <v-avatar color="error" size="70">
          <v-icon color="white" large>fas fa-times</v-icon>
        </v-avatar>
      </div>
    </v-theme-provider>

    <div class="d-flex justify-center body-heading-large text-center my-8">
      {{ failedMsgTitle }}
    </div>
    <div class="d-flex justify-center body-text-small text-center my-8">
      {{ failedMsgSubtitle }}
    </div>
    <v-card-text class="d-flex justify-center">
      <v-row v-if="failedActions.length == 2">
        <v-col :key="failedActions[0].name" cols="12" md="6" class="d-flex justify-center justify-md-end">
          <v-btn outlined color="secondary" @click="failedActions[0].event">{{ failedActions[0].name }}</v-btn>
        </v-col>
        <v-col :key="failedActions[1].name" cols="12" md="6" class="d-flex justify-center justify-md-start">
          <v-btn color="secondary" @click="failedActions[1].event">{{ failedActions[1].name }}</v-btn>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col v-for="(action, index) in failedActions" :key="action.name" cols="12" :md="failedActions.length == 2 ? 6 : 12" class="d-flex justify-center">
          <v-btn @click="action.event" :outlined="index == 0" color="secondary">{{ action.name }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: "ResultCard",
    props: {
      success: {
        type: Boolean,
        required: true,
      },
      successMsgTitle: {
        type: String,
        default: "Success!",
      },
      successMsgSubtitle: {
        type: String,
      },
      failedMsgTitle: {
        type: String,
        default: "Opps!",
      },
      failedMsgSubtitle: {
        type: String,
        default: "Looks like something went wrong, please try again later.",
      },
      successActions: {
        type: Array,
      },
      failedActions: {
        type: Array,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ResultCard.vue